<div>
   <div class="row">
        <div class="col-md-12">
            <div class="card-box" v-if="!loading">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Order #</th>
                                <th>Order Date</th>
                                <th>Vehicle</th>
                                <th>Fleet Number</th>
                                <th>Manifest Number</th>
                                <th>Total</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order, index) in recentCollectionOrders" :key="index">
                                <td>{{order.orderId}}</td>
                                <td>{{order.orderDate}}</td>
                                <td>{{order.vehicle}}</td>
                                <td>{{order.fleetNumber}}</td>
                                <td>{{order.manifestNumber}}</td>
                                <td>R{{order.total}}</td>
                                <td>{{order.orderStatus}}</td>
                                <td>
                                    <div class="dropdown">
                                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Action
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                                            <button class="dropdown-item" >Action 1</button>
                                        </div>
                                    </div>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div>
                
                
            </div>
            <loading-spinner :showSpinner="loading"></loading-spinner>
        </div>
   </div>
</div>
